<template>
    <div class="navigation-bar" :style="{ paddingTop: statusBarH + 'px' }">
        <div class="navigation-bar-main">
            <div class="main-title">
                <div class="main-title-left" ref="leftDom" :style="styleObj" @click="leftClick">
                    <slot name="left">
                        <div class="icon-c">
                            <SvgIcon :name="leftIconName"></SvgIcon>
                        </div>
                        <!--                        || $t('returnTxt')-->
                        <div class="left-txt">{{ leftTxt }}</div>
                    </slot>
                </div>
                <div class="main-title-center">
                    <slot>
                        {{ title }}
                    </slot>
                </div>
                <div class="main-title-right" ref="rightDom" :style="styleObj" @click="rightClick">
                    <slot name="right">
                        <SvgIcon v-if="rightIconName" :name="rightIconName"></SvgIcon>
                    </slot>
                </div>
            </div>
            <div class="sub-title">
                <slot>
                    {{ subTitle }}
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    export default {
        name: 'NavigationBar',
        props: {
            leftIconName: {
                type: String,
                default: 'arrow-left',
            },
            leftTxt: String,
            title: String,
            rightIconName: String,
            subTitle: String,
            // 是否左右的宽度相同, 即保证 title 在屏幕中心
            symmetric: {
                type: Boolean,
                default: true,
            },
            autoLeftEvent: {
                type: Boolean,
                default: true,
            },
            // // 是否是最后的页面了? 如果是, 那么在 autoLeftEvent 开启的情况下就会 调用原生方法返回, 而不是前端返回
            isLastPage: Boolean,
        },
        data() {
            return {
                maxW: 0,
            };
        },
        computed: {
            styleObj() {
                if (this.symmetric && this.maxW) {
                    return {
                        width: `${this.maxW}px`,
                    };
                }
                return {};
            },
            statusBarH() {
                return store.state.device.statusBarH;
            },
        },
        created() {
            this.reSize = this.reSize.bind(this);
        },
        mounted() {
            this.$nextTick(() => {
                if (this.symmetric) {
                    setTimeout(() => {
                        try {
                            this.getMaxW();
                            this.initEvent();
                        } catch (e) {
                            // pass
                        }
                    }, 10);

                    setTimeout(() => {
                        try {
                            this.getMaxW();
                        } catch (e) {
                            // pass
                        }
                    }, 300);

                    setTimeout(() => {
                        try {
                            this.getMaxW();
                        } catch (e) {
                            // pass
                        }
                    }, 1000);
                }
            });
        },
        beforeDestroy() {
            this.unEvent();
        },
        methods: {
            getMaxW() {
                const leftEl = this.$refs.leftDom;
                const rightEl = this.$refs.rightDom;
                const elMaxW = Math.max(leftEl.offsetWidth, rightEl.offsetWidth);
                // 解释一下, 为什么+1, 因为获取的宽度可能有小数位的缺失, 导致宽度不够,从而换行的问题
                console.log(
                    leftEl.offsetWidth,
                    rightEl.offsetWidth,
                    elMaxW,
                    'leftEl, rightEl, elMaxW',
                );
                this.maxW = elMaxW + 1;
            },
            reSize() {
                this.maxW = 0;
                this.$nextTick(() => {
                    this.getMaxW();
                });
            },
            initEvent() {
                window.addEventListener('resize', this.reSize);
            },
            unEvent() {
                window.removeEventListener('resize', this.reSize);
            },
            leftClick() {
                this.$emit('leftClick');
                // 自动处理事件
                if (this.autoLeftEvent) {
                    if (this.isLastPage) {
                        // pass
                    } else {
                        console.log('go-------------------触发');
                        this.$router.go(-1);
                        setTimeout(() => {
                            console.log('当前URL', document.URL);
                        }, 1000);
                        // router.back();
                    }
                }
            },
            rightClick() {
                this.$emit('rightClick');
            },
        },
    };
</script>

<style scoped lang="less">
    .navigation-bar {
        background-color: @card-bg;
        position: sticky;
        top: 0;
        left: 0;
        width: 100%;
        font-size: @txt-size-navigation;
        color: @txt-color-1;
        padding: 0 13.5px;
        z-index: 100;
        padding-bottom: 7px;
        .navigation-bar-main {
            //height: 36px;
            padding-top: 22px;
            .main-title {
                .minx-flex-c-b();

                .main-title-left {
                    .minx-flex-c();
                    justify-content: flex-start;
                    .icon-c {
                        font-size: 18px;
                    }
                    .left-txt {
                        margin-left: 4px;
                        font-size: @txt-size-content1;
                        font-weight: 500;
                        text-align: left;
                        color: @txt-color-2;
                    }
                }

                .main-title-center {
                    flex: 1;
                    .overflow-ellipsis();
                    padding: 0 10px;

                    font-size: @txt-size-navigation;
                    font-weight: bold;
                    text-align: center;
                    color: @txt-color-2;
                }
                .main-title-right {
                    .minx-flex-c();
                    justify-content: flex-end;
                }
            }
            .sub-title {
                margin-top: 2px;
                font-size: @txt-size-content2;
                font-weight: 500;
                text-align: center;
                color: @txt-color-3;
                .overflow-ellipsis();
            }
            .main-title-right {
                .minx-flex-c();
            }
        }
    }
</style>
